import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { getProjectFormAttention } from '../services/getProjectFormAttention.service';

/**
 * Loads one of the project overview's form lists for today, in the user's
 * own time zone: `kind` 'nonConformance' (reports unprocessed or done today)
 * or 'trMeters' (TR meters with deficiencies to fix or done today).
 *
 * A 403 — no access after all — resolves as `{ noAccess: true }`, as the
 * forms page's loads do, so the section stays away rather than erroring.
 */
export const loadProjectFormAttention = createAsyncThunk(
  'projectOverview/loadFormAttention',
  async ({ projectId, kind }) => {
    try {
      return await getProjectFormAttention({
        projectId,
        kind,
        dayStart: moment().startOf('day').toISOString(),
        dayEnd: moment().endOf('day').toISOString(),
      });
    } catch (error) {
      if (error?.response?.status === 403) {
        return { noAccess: true };
      }
      throw error;
    }
  },
  {
    // One request per list and project at a time.
    condition: ({ projectId, kind }, { getState }) =>
      getState().projectOverview?.formAttention?.[kind]?.[projectId]?.status !==
      'loading',
  }
);
